// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from '../index';
import { getLogs } from 'api/logs';

// ----------------------------------------------------------------------

const defaultParams = {
    query: '',
    pageNo: 1,
    perPage: 10,
    sortBy: 'createdAt',
    sortDirection: 'DESC',
    dateFrom: new Date(),
    dateTo: new Date()
};

const initialState = {
    // for dashboard
    recent: {
        logs: [],
        isFetching: true,
        total: 0,
        params: defaultParams
    },
    // for modal
    activities: {
        logs: [],
        isFetching: true,
        total: 0,
        params: defaultParams
    },
    // for account settings profile
    profileActivities: {
        logs: [],
        isFetching: true,
        total: 0,
        params: defaultParams
    },
    totalLogsCount: 0
};

const slice = createSlice({
    name: 'logs',
    initialState,
    reducers: {
        // SET Logs
        setLogs(state, action) {
            const { data, isUpdateTotalCount, type } = action.payload;
            const { list = [], summary } = data;
            if (type === 'recent-activities') {
                state.recent.logs = list;
                if ((state.recent.total === 0 || isUpdateTotalCount) && summary) {
                    const { total = 0, overallTotal = 0 } = summary;
                    state.recent.total = total;
                    state.totalLogsCount = overallTotal;
                }
            } else if (type === 'activities') {
                state.activities.logs = list;
                if ((state.activities.total === 0 || isUpdateTotalCount) && summary) {
                    const { total = 0 } = summary;
                    state.activities.total = total;
                }
            } else {
                state.profileActivities.logs = list;
                if ((state.profileActivities.total === 0 || isUpdateTotalCount) && summary) {
                    const { total = 0 } = summary;
                    state.profileActivities.total = total;
                }
            }

            // we will update the count
            if ((state.resourcesCount === 0 || isUpdateTotalCount) && summary) {
                const { total = 0, overallTotal = 0 } = summary;
                state.logsCount = total;
                state.totalLogsCount = overallTotal;
            }
        },
        // SET Params
        setParams(state, action) {
            const { params, type } = action.payload;
            if (type === 'recent-activities') {
                state.recent.params = params;
            } else if (type === 'activities') {
                state.activities.params = params;
            } else {
                state.profileActivities.params = params;
            }
        },
        // SET Is Fetcing Resources
        setIsFetchingLogs(state, action) {
            const { status, type } = action.payload;
            if (type === 'recent-activities') {
                state.recent.isFetching = status;
            } else if (type === 'activities') {
                state.activities.isFetching = status;
            } else {
                state.profileActivities.isFetching = status;
            }
        }
    }
});

// eslint-disable-next-line prettier/prettier
export const {
    setLogs,
    setParams,
    setIsFetchingLogs,
} = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function fetchLogs(params, isUpdateTotalCount = false, type = 'recent-activities') {
    return async () => {
        try {
            const result = await getLogs(params);
            dispatch(
                slice.actions.setLogs({
                    data: result?.data || [],
                    isUpdateTotalCount,
                    type
                })
            );
            return result?.data?.list || [];
        } catch (error) {
            console.log('error', error);
            dispatch(
                slice.actions.setLogs({
                    data: {
                        list: []
                    },
                    type
                })
            );
            return [];
        }
    };
}
